module.exports = __webpack_public_path__ + "static/active-beach.f414a06c.png";